import {
  SET_COMMENTS,
  ADD_COMMENTS,
  SET_COMMENTS_PAGING,
  COMMENTS_LOADING,
} from '../../constants';
import { getComments } from '../api/instagramApi';
import triggerEvent from './biSiteLogger';
import biData from '../../bi/profileEvents.json';
import { bindActionCreators } from '../../../node_modules/redux';

/**
 * Get comments by mediaId
 * @param {*} mediaId - id of media
 */
export const getCommentsByMediaId = (
  dispatch,
  mediaId,
  commentsPagination,
  accessToken,
  userId,
  isTemplate,
) => {
  const after = commentsPagination[mediaId] || '';
  const typeAction = after ? ADD_COMMENTS : SET_COMMENTS;

  dispatch({
    type: COMMENTS_LOADING,
    payload: {
      [mediaId]: true,
    },
  });

  getComments(mediaId, after, accessToken, userId, isTemplate).then(
    (newData) => {
      if (!newData) return;

      const newAfter =
        (newData.paging &&
          newData.paging.cursors &&
          newData.paging.cursors.after) ||
        '';

      dispatch({
        type: COMMENTS_LOADING,
        payload: {
          [mediaId]: false,
        },
      });

      dispatch({
        type: typeAction,
        payload: {
          mediaId,
          newData: newData.data,
        },
      });

      dispatch({
        type: SET_COMMENTS_PAGING,
        payload: {
          [mediaId]: newAfter,
        },
      });
    },
  );
};
